<template>
  <Drawer title="锐明-附件丢失" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'rmlossattachmentmodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: null
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: '平台与设备通道不一致',
          description: '1、重新勾选对应摄像头通道'
          // content: '2、安排上门维修更换SIM卡',
          // imgSrc: '/BSJ/video/PlugCamera.jpg',
        },
        {
          title: '硬盘损坏',
          description: '1、两客一危（省厅）及易流均无附件',
          content: '2、查询历史视频核实硬盘是否正常',
          dispose: '3、安排上门维修更换硬盘',
          imgSrc: '/RM/NOT XRV4/HardDiskDamage.png'
          // pdfSrc: "/RM/RM-ExportVideo.pdf",
        },
        {
          title: '报警参数设置错误',
          description: '1、两客一危（省厅）及易流均无附件/附件不完整',
          content: '2、查询报警参数',
          // dispose: '3、安排上门维修更换硬盘',
          imgSrc: '/RM/AlarmSetting2.jpg',
          pdfSrc: '/RM/RM-AlarmSetting.pdf'
        },
        {
          title: '参数设置错误',
          description: '1、易流平台正常，两客一危（省厅）无附件',
          content: '2、检查设备两客一危（省厅）服务器1：IP，端口，协议版本（808版本号），客户编码：54',
          dispose: '3、设备两客一危（省厅）服务器1参数无误，网络波动/平台服务器堵塞导致',
          imgSrc: '/RM/NOT XRV4/Parameterexception.png',
          pdfSrc: '/RM/RM-IPSET.pdf'
        },
        {
          title: '平台过滤',
          description: '1、两客一危（省厅）正常，易流平台无附件',
          content: '2、咨询易流平台是否对报警附件做过滤'
          // imgSrc: '/BSJ/A6BD/Parameterexception.jpg',
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>

</style>
